"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const estadoInicial_1 = require("./estadoInicial");
const tratativasAutenticacaoFactory = (dispatch) => {
    const onUsuarioLogin = async ({ usuarioFirebase, pessoa, organizacao, }) => {
        dispatch({
            type: 'ATUALIZAR_DADOS_AUTENTICACAO',
            payload: {
                pessoa,
                organizacao,
                usuarioFirebase,
                autenticacaoLoading: false,
            },
        });
    };
    const onLogout = () => dispatch({
        type: 'ATUALIZAR_DADOS_AUTENTICACAO',
        payload: {
            pessoa: estadoInicial_1.ESTADO_INICIAL.pessoa,
            organizacao: estadoInicial_1.ESTADO_INICIAL.organizacao,
            usuarioFirebase: estadoInicial_1.ESTADO_INICIAL.usuarioFirebase,
            autenticacaoLoading: false,
        },
    });
    return { onUsuarioLogin, onLogout };
};
exports.default = tratativasAutenticacaoFactory;
//# sourceMappingURL=tratativasAutenticacao.js.map